export default {
  /*
   * create() crea una recarga del movil
   */
  create(params) {
    return Vue.http.post('billing/mobile_recharges', params).then(response => response.data.data)
  },
  /*
   * show() devuelve los datos de una recarga del movil
   */
  show(id, params) {
    return Vue.http.get(`billing/mobile_recharges/${id}`, params).then(
      response => response.data.data
    )
  },
  /*
   * index() devuelve una lista de recargas del móvil
   */
  index(params) {
    return Vue.http.get('billing/mobile_recharges', {params}).then(response => response.data.data)
  }
}
